export const DocsKind = {
  Namespace: 4,
  Variable: 32,
  Function: 64,
  Class: 128,
  Interface: 256,
  Property: 1024,
};

export const DocsContentKind = {
  Code: "code",
  Text: "text",
};

export const DocsTag = {
  Returns: "@returns",
  Param: "@param",
};

export const DocsType = {
  Literal: "literal",
  Reference: "reference", // a declared type
  Reflection: "reflection",
  Tuple: "tuple",
  Union: "union",
  Conditional: "conditional",
  Array: "array",
  TypeOperator: "typeOperator", // e.g. readonly
};
